const prefix = '/praticiens';

const Routes = {
  Book: prefix + '/{id}/prendre-rdv',
};

export default Routes;
